import { BaseError } from "./BaseError";
import type { ErrorContext } from "../types/index";
import { INTERNAL_ERROR_CODES } from "../constants/errorCodes";

export interface InternalErrorOptions {
  message: string;
  context?: Partial<ErrorContext>;
  code?: string;
  cause?: Error;
}

/**
 * Error thrown for internal server errors
 */
export class InternalError extends BaseError {
  constructor(options: InternalErrorOptions) {
    super({
      message: options.message,
      category: "internal",
      severity: "critical",
      statusCode: 500,
      code: options.code ?? INTERNAL_ERROR_CODES.INTERNAL_ERROR,
      context: options.context,
      cause: options.cause,
      userVisible: false,
      reportable: true,
    });
  }
}
